import z from 'zod';
export const FIRM_SUBSCRIPTION_STATUS_PENDING_CHECKOUT = 'pending_checkout';
export const FIRM_SUBSCRIPTION_STATUS_ACTIVE = 'active';
export const FIRM_SUBSCRIPTION_STATUS_PAYMENT_PENDING = 'payment_pending';
export const FIRM_SUBSCRIPTION_STATUS_SUSPENDED = 'suspended';
export const FIRM_SUBSCRIPTION_STATUS_CANCELLED = 'cancelled';
export const FIRM_SUBSCRIPTION_STATUS_EXPIRED = 'expired';
export const firmSubscriptionStatusValue = z.enum([
    FIRM_SUBSCRIPTION_STATUS_ACTIVE,
    FIRM_SUBSCRIPTION_STATUS_CANCELLED,
    FIRM_SUBSCRIPTION_STATUS_EXPIRED,
    FIRM_SUBSCRIPTION_STATUS_PAYMENT_PENDING,
    FIRM_SUBSCRIPTION_STATUS_PENDING_CHECKOUT,
    FIRM_SUBSCRIPTION_STATUS_SUSPENDED,
]);
export const firmSubscriptionStatus = (value) => firmSubscriptionStatusValue.parse(value);
export const isFirmSubscriptionStatus = (value) => firmSubscriptionStatusValue.safeParse(value).success;
export const isFirmSubscriptionStatusExpired = (status) => status === FIRM_SUBSCRIPTION_STATUS_EXPIRED;
export const isFirmSubscriptionStatusActive = (status) => status === FIRM_SUBSCRIPTION_STATUS_ACTIVE;
export const isFirmSubscriptionStatusSuspended = (status) => status === FIRM_SUBSCRIPTION_STATUS_SUSPENDED;
export const isFirmSubscriptionStatusPendingCheckout = (status) => status === FIRM_SUBSCRIPTION_STATUS_PENDING_CHECKOUT;
export const isFirmSubscriptionStatusPaymentPending = (status) => status === FIRM_SUBSCRIPTION_STATUS_PAYMENT_PENDING;
export const isFirmSubscriptionStatusCancelled = (status) => status === FIRM_SUBSCRIPTION_STATUS_CANCELLED;
export const isFirmSubscriptionActive = (firmSubscriptionStatus) => {
    if (!firmSubscriptionStatus) {
        return false;
    }
    return isFirmSubscriptionStatusActive(firmSubscriptionStatus);
};
/**
 * @deprecated Use `isFirmSubscriptionActive` instead.
 */
export const isFirmSubscriptionOngoing = isFirmSubscriptionActive;
//# sourceMappingURL=firm-subscription-status.js.map